module.exports = __webpack_public_path__ + "img/studysheets.40ca4e55.png";